import { render } from "./commonAgreement2.vue?vue&type=template&id=175460a7"
import script from "./commonAgreement2.vue?vue&type=script&lang=js"
export * from "./commonAgreement2.vue?vue&type=script&lang=js"

import "./commonAgreement2.vue?vue&type=style&index=0&id=175460a7&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__